import { useRootMails } from '@/hooks/useMails';
import { MailRow } from './MailRow';

interface Props {
  containerId: string;
  depth: number;
}

/**
 * Mails filed at the project ROOT (folder_id null), shown directly under the
 * project header, above its folders. Lazy — only mounts while the section is
 * expanded. Renders nothing (no spinner) until/unless there are root mails, so
 * the common "project has no root mails" case adds no visual noise.
 */
export function ContainerRootMails({ containerId, depth }: Props) {
  const { data, isPending, isError } = useRootMails(containerId);
  if (isPending || isError || !data || data.length === 0) return null;
  return (
    <>
      {data.map((mail) => (
        <MailRow key={mail.id} mail={mail} depth={depth} />
      ))}
    </>
  );
}
